import { WithUserLayout } from "@/components/UserLayout";
import { Title } from "../components/Title";
import { Page } from "../types/Page";
import Hero from "@/components/Hero";
import ButtonLink from "@/components/ButtonLink";
import CompanyValues from "@/components/Dashboard/CompanyValues";
import Dashboard from "@/components/Dashboard/Dashboard";
import { GetCompanyIntro } from "@/services/CompanyService";

// const dummyData: CompanyPrograms[] = [
//   {
//     id: "6c2e1a36-8114-4e75-9441-4e7e587bf663",
//     title: "I Like Monday",
//     description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo fugiat pariatur aperiam maxime quia ratione nemo cumque in tempore ea! Quas ipsum dolorem consequuntur accusamus natus possimus voluptate fugiat facilis.",
//     ordering: "1",
//     contentPosition: "Left",
//     blobId: "6c2e1a36-8114-4e75-9441-4e7e587bf663"
//   },
//   {
//     id: "6c2e1a36-8114-4e75-9441-4e7e587bf664",
//     title: "I Like Sunday",
//     description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo fugiat pariatur aperiam maxime quia ratione nemo cumque in tempore ea! Quas ipsum dolorem consequuntur accusamus natus possimus voluptate fugiat facilis.",
//     ordering: "1",
//     contentPosition: "Right",
//     blobId: "6c2e1a36-8114-4e75-9441-4e7e587bf663"
//   },
//   {
//     id: "6c2e1a36-8114-4e75-9441-4e7e587bf665",
//     title: "I Like Tuesday",
//     description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo fugiat pariatur aperiam maxime quia ratione nemo cumque in tempore ea! Quas ipsum dolorem consequuntur accusamus natus possimus voluptate fugiat facilis.",
//     ordering: "1",
//     contentPosition: "Left",
//     blobId: "6c2e1a36-8114-4e75-9441-4e7e587bf663"
//   },
//   {
//     id: "6c2e1a36-8114-4e75-9441-4e7e587bf666",
//     title: "I Like Wednesday",
//     description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo fugiat pariatur aperiam maxime quia ratione nemo cumque in tempore ea! Quas ipsum dolorem consequuntur accusamus natus possimus voluptate fugiat facilis.",
//     ordering: "2",
//     contentPosition: "Right",
//     blobId: "6c2e1a36-8114-4e75-9441-4e7e587bf663"
//   },
//   {
//     id: "6c2e1a36-8114-4e75-9441-4e7e587bf667",
//     title: "I Like Thursday",
//     description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo fugiat pariatur aperiam maxime quia ratione nemo cumque in tempore ea! Quas ipsum dolorem consequuntur accusamus natus possimus voluptate fugiat facilis.",
//     ordering: "3",
//     contentPosition: "Left",
//     blobId: "6c2e1a36-8114-4e75-9441-4e7e587bf663"
//   },
//   {
//     id: "6c2e1a36-8114-4e75-9441-4e7e587bf668",
//     title: "I Like Friday",
//     description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo fugiat pariatur aperiam maxime quia ratione nemo cumque in tempore ea! Quas ipsum dolorem consequuntur accusamus natus possimus voluptate fugiat facilis.",
//     ordering: "3",
//     contentPosition: "Left",
//     blobId: "6c2e1a36-8114-4e75-9441-4e7e587bf663"
//   },
// ]

const IndexPage: Page = () => {

  const  intro  = GetCompanyIntro();
  
  const dataIntro = intro && intro[0];

  const modifyTitle = (text: string) => {
    const words = text.trim().split(/\s+/);
    const lastWord = words.pop();
    const secondLastWord = words.pop();
    const firstPart = words.join(" ");

    return `${firstPart ? `${firstPart} ` : ""} <br /> ${secondLastWord ? `${secondLastWord} ` : ""
      } ${firstPart || secondLastWord
        ? `<span style="color: #93885B;">${lastWord}</span>`
        : lastWord
      }`;
  };

  return (
    <div className="relative ">
      <div className="pb-10 md:pb-0">
        <Title>Career</Title>
        <Hero backgroundImage={`${dataIntro?.minioUrl}`}>
          <h1
            className="text-4xl font-semibold text-white pt-10"
            dangerouslySetInnerHTML={{
              __html: modifyTitle(dataIntro?.title || ""),
            }}
          ></h1>
          <h2
            className="pt-3 text-white w-1/3"
            dangerouslySetInnerHTML={{
              __html: dataIntro?.description || "",
            }}
          ></h2>
          <div className="pt-8 pb-5 sm:pb-0 md:pb-28 lg:pb-20 text-white">
            <ButtonLink
              href="/vacancy"
              title="Discover the job you want"
              type="primary"
            />
          </div>
        </Hero>
      </div>
      <div className="pb-0 lg:pb-4 xl:pb-0">
        <CompanyValues />
      </div>
      <Dashboard />
    </div>
  );
};

IndexPage.layout = WithUserLayout;
export default IndexPage;
